module.exports = __webpack_public_path__ + "static/tracking-4ce14ba965cd7ad721917b29e0b58c28.jpg";